import { render, staticRenderFns } from "./ColaPacienteView.vue?vue&type=template&id=e9305080"
import script from "./ColaPacienteView.vue?vue&type=script&lang=js"
export * from "./ColaPacienteView.vue?vue&type=script&lang=js"
import style0 from "./ColaPacienteView.vue?vue&type=style&index=0&id=e9305080&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports